export default "__VITE_ASSET__mDfAr7Ox__"